<template>
    <div
        class="flex justify-between rounded-t mt-6"
        v-bind:class="[`light-${titleColor}`,otherClass]"
    >
        <div class="flex justify-start">
            <div
                class="flex-no-shrink step-header flex align-center text-center text-white px-6 py-2 text-base sm:text-lg md:text-xl text-grey-darker"
                :class="titleColor"
            >
                <div class="flex rounded-r-full items-center ">
                    <slot name="title"></slot>
                </div>
            </div>
            <div class="flex-auto flex align-center text-center px-4 py-2 m-2">
                <slot name="text"></slot>
            </div>
        </div>
        <div class="flex justify-end items-center">
            <slot name="header-end"></slot>
        </div>
    </div>
    <!-- <nav class="level stepBar" v-bind:class="[barColor,otherClass]">
    <div class="level-left stepLeft">
        <div class="level-item has-text-centered stepHeader" v-bind:class="titleColor">
            <div class="is-size-3-desktop is-size-5-touch">
                <slot name="title"></slot>
            </div>
        </div>

    </div>
    <div class="level-right">
        <div class="level-item">
            <div class="sm:text-xs md:text-sm lg:text-base xl:text-xl">
                <slot name="text"></slot>
            </div>
        </div>
    </div>
</nav> -->
</template>
<script>
export default {
    props: {
        titleColor: {
            required: true
        },
        barColor: {
            default: "white"
        },
        otherClass: {
            required: false
        }
    }
};
</script>
<style>
.calc-step-box-shadow {
    box-shadow: 0px 0px 10px 3px #5f5d5d;
}

.green {
    background-color: #75b34b;
}

.light-green {
    background-color: #75b34b1a;
}

.orange {
    background-color: #f19f28;
}

.light-orange {
    background-color: #f1a12826;
}

.blue {
    background-color: #165da6;
}
.light-blue {
    background-color: #165ea626;
}

.purple {
    background-color: #ae377f;
}

.light-purple {
    background-color: #ae377e26;
}

.white {
    background-color: white;
}

.step-title {
    color: white;
    font-weight: 300;
    line-height: 1.125;
}

.first-step {
    margin-top: 40px !important;
}

.step-header {
    border-radius: 0.25rem 2rem 2rem 0;
    -moz-border-radius: 0.25rem 2rem 2rem 0;
    -webkit-border-radius: 0.25rem 2rem 2rem 0;
}
</style>
